import { Component, OnInit, Input } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { RequestDocAttachmentDto, RequestDocAttachmentResponse } from '../shared/models/requestDocAttachment';
import { Fancybox } from '@fancyapps/ui';

@Component({
    selector: 'xp-attachment-list',
    templateUrl: './attachment-list.component.html',
    styleUrl: './attachment-list.component.scss'
})
export class AttachmentListComponent implements OnInit {
    displayedColumns: string[] = ["Name", "DocumentType", "FileSize", "Actions"];
    noAttachmentData: boolean = false;
    dataSource: MatTableDataSource<RequestDocAttachmentDto>;
    DOCUMENT_DATA: RequestDocAttachmentDto[] = [];
    @Input() attachments: RequestDocAttachmentDto[] | undefined = undefined;
    hasAttachments: boolean = false;
    fileToBeDownloaded!: RequestDocAttachmentResponse;

    constructor(private http: HttpClient) {
        this.dataSource = new MatTableDataSource<RequestDocAttachmentDto>(this.DOCUMENT_DATA);
    }

    ngOnInit(): void {
        this.hasAttachments = this.attachments != undefined && this.attachments.length > 0;

        if (!this.hasAttachments) {
            this.noAttachmentData = true;
        }

        if (this.attachments != undefined) {
            this.dataSource.data = this.attachments;
        }
    }

    ngOnDestroy() {
        Fancybox.close();
    }

    viewDocument(attachment: RequestDocAttachmentDto) {
        const previewUrl = attachment.canPreviewPdf
            ? `/api/request-doc/download/${attachment.id}?findPdf=true`
            : `/api/request-doc/download/${attachment.id}`;

        this.http.get(previewUrl, { responseType: 'blob' }).subscribe({
            next: blob => {
                const objectUrl = URL.createObjectURL(blob);
                window.open(objectUrl, '_blank');
            },
            error: err => {
                console.error('Preview failed:', err);
            }
        });
    }

    downloadDocument(attachment: RequestDocAttachmentDto) {
        this.http.get(`/api/request-doc/download/${attachment.id}?download=true`, {
            observe: 'response',
            responseType: 'blob'
        }).subscribe({
            next: (response: HttpResponse<Blob>) => {
                const blob = response.body;

                if (!blob) {
                    throw new Error('Empty download response');
                }

                const contentDisposition = response.headers.get('content-disposition');
                const fileNameMatch = contentDisposition?.match(/filename="?([^"]+)"?/);
                const fileName = fileNameMatch?.[1] || attachment.fileName || 'file';

                const url = URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = fileName;
                anchor.style.display = 'none';
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
                URL.revokeObjectURL(url);
            },
            error: err => {
                console.error('Download failed:', err);
            }
        });
    }
}
